module.exports = __webpack_public_path__ + "media/images/cta-bg-2dd27ca5b882391f83e4d04ad02cc03c.jpg";